import base64 from '../base64';

export function convertBase64ToPeaks(base64Peaks: string): Uint8Array | null {
  return base64Peaks ? base64.decode(base64Peaks) : null;
}
